// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"144e0577","173":"c75bbafc","191":"cf5b12bf","515":"12771d6c","612":"c06897ad","947":"bcd86ad9"}[chunkId] + ".chunk.js";
};